<script>
    import { onMount } from "svelte";

    export let items = [];

    let imageList = null;
    const zoomLevels = ['zoom-level-0','zoom-level-1','zoom-level-2','zoom-level-3','zoom-level-4']
    let currentZoomLevelIndex = 2;
    const currentZoomLevel = () => zoomLevels[currentZoomLevelIndex];
    const zoomOut = () => {
        imageList.classList.remove(currentZoomLevel());
        currentZoomLevelIndex--;
        if (currentZoomLevelIndex < 0) {
            currentZoomLevelIndex = 0;
        }
        imageList.classList.add(currentZoomLevel());
    }

    const zoomIn = () => {
        imageList.classList.remove(currentZoomLevel());
        currentZoomLevelIndex++;
        if (currentZoomLevelIndex >= zoomLevels.length) {
            currentZoomLevelIndex = zoomLevels.length - 1;
        }
        imageList.classList.add(currentZoomLevel());
    }

    onMount(() => {
        imageList.classList.add(zoomLevels[currentZoomLevelIndex]);
    });
</script>

<section>
    <header>
        <slot name="header"></slot>
        <button on:click={zoomOut}>-</button>
            <span>Zoom</span>
        <button on:click={zoomIn}>+</button>
    </header>
    <ul class="view-mode-grid" bind:this={imageList} >
        {#each items as item}
            <slot name="listItem" {item}></slot>
        {/each}
    </ul>
</section>
